// Centralized tooltip configuration for all icon buttons
export const tooltips = {
  // Header navigation
  search: 'Search articles',
  write: 'Write new article',
  dashboard: 'Dashboard',

  // Theme toggle
  themeLight: 'Light mode',
  themeSystem: 'System preference',
  themeDark: 'Dark mode',

  // Article actions
  editArticle: 'Edit article',
  deleteArticle: 'Delete article',

  // Write/Edit page
  saveDraft: 'Save as draft',
  publish: 'Publish article',
  discardChanges: 'Discard changes',

  // Comment section
  postComment: 'Post comment',

  // General
  close: 'Close',
  back: 'Go back',
  share: 'Share',
  copy: 'Copy to clipboard',
} as const;

export type TooltipKey = keyof typeof tooltips;
